module.exports = __webpack_public_path__ + "static/media/printer.7cb031dc.svg";